import { render } from "./TaskSidebar.vue?vue&type=template&id=388f8254&scoped=true&ts=true"
import script from "./TaskSidebar.vue?vue&type=script&lang=ts"
export * from "./TaskSidebar.vue?vue&type=script&lang=ts"

import "./TaskSidebar.vue?vue&type=style&index=0&id=388f8254&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388f8254"]])

export default __exports__